import React, { useState, useEffect } from "react";
import AgGridComponent from "../../Components/Common/AgGridComponent";
import api from "../../Utils/api";
import _ from "lodash";
import { ISOToDateTime } from "../../Components/Common/Common";
import { Form, Col, Modal, Button, Row } from "react-bootstrap";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Select from "react-select";
import PartyMasterDD from "../PartyMaster/PartyMasterDD";
import Loader from "../../Components/Common/Loader";
import { getCurrentDate } from "../../Utils/commonfunctions";
import ReactDOM from "react-dom";
import ExcelJS from "exceljs";
import { saveAs } from "file-saver";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowsLeftRight, faArrowsUpDown, faDumbbell, faGem } from "@fortawesome/free-solid-svg-icons";

const sumAggFunc = (params) => {
  const values = params.values;
  let sum = 0;

  values.forEach((value) => {
    sum += value;
  });

  return sum;
};

const pinnedBottomRowData = [
  {
    receivedDate: null,
    stoneNo: "",
    stoneType: "TOTAL",
    pcs: 0,
    length: 0,
    width: 0,
    height: 0,
    weight: 0,
    rW_Weight: 0,
    r_Weight: 0,
    eM_Weight: 0,
    oV_Weight: 0,
    pN_Weight: 0,
    cU_Weight: 0,
  },
];

var selectedBagForCreateJangad = [];

export default function CurrentBagstockofuser({ subUserID }) {
  const [stoneList, setStoneList] = useState([]);
  const [totalStock, setTotalStock] = useState({
    totalPcs: 0,
    totalLength: 0,
    totalWidth: 0,
    totalHeight: 0,
    totalWeight: 0,
  });

  const [isLoading, setIsLoading] = useState(false);

  // const [sums, setSums] = useState({
  //   footerTotalPcs: 0,
  //   footerTotalLength: 0,
  //   footerTotalWidth: 0,
  //   footerTotalHeight: 0,
  //   footerTotalWeight: 0,
  //   footerTotalRW_Weight: 0,
  //   footerTotalR_Weight: 0,
  //   footerTotalEM_Weight: 0,
  //   footerTotalOV_Weight: 0,
  //   footerTotalPN_Weight: 0,
  //   footerTotalCU_Weight: 0,
  // });

  useEffect(() => {
    getStockList();
  }, [subUserID]);

  const getStockList = () => {
    setIsLoading(true); // Show loader
    api
      .get(`Stone/CurrentStockOfBagAsPrUser?UserID=${subUserID}`)
      .then((result) => {
        setStoneList(result.data.data.listStoneDataModel);
        // setTotalStock({
        //   totalPcs: result.data.data.totalStoneSummary.pcs,
        //   totalLength: result.data.data.totalStoneSummary.length,
        //   totalWidth: result.data.data.totalStoneSummary.width,
        //   totalHeight: result.data.data.totalStoneSummary.height,
        //   totalWeight: result.data.data.totalStoneSummary.weight,
        // });
      })
      .catch((error) => {
        console.log(error);
      })
      .finally(() => {
        setIsLoading(false); // Hide loader
      });
  };

  useEffect(() => {
    updatePinnedBottomRowData();
    setTopTotal();
  }, [stoneList]);

  const setTopTotal = (event) => {
    const sums = calculateSums(event);
    setTotalStock({
      totalPcs: sums.footerTotalPcs, // Set total pcs
      totalLength: sums.footerTotalLength.toFixed(2), // Format to 2 decimal places
      totalWidth: sums.footerTotalWidth.toFixed(2), // Format to 2 decimal places
      totalHeight: sums.footerTotalHeight.toFixed(2), // Format to 2 decimal places
      totalWeight: sums.footerTotalWeight.toFixed(2), // Format to 2 decimal places
    });
  };

  const calculateSums = (event) => {
    let filteredData;
    if (event === undefined) {
      filteredData = stoneList;
    } else {
      filteredData = event.api.getModel().rowsToDisplay.map((row) => row.data);
    }

    const filteredSumPcs = _.sumBy(filteredData, "pcs");

    let totalLength = 0;
    let totalWidth = 0;
    let totalHeight = 0;
    filteredData.forEach((item) => {
      totalLength += item.pcs * item.length;
      totalWidth += item.pcs * item.width;
      totalHeight += item.pcs * item.height;
    });

    const filteredSumLength = parseFloat(
      (totalLength / filteredSumPcs).toFixed(2)
    );
    const filteredSumWidth = parseFloat(
      (totalWidth / filteredSumPcs).toFixed(2)
    );
    const filteredSumHeight = parseFloat(
      (totalHeight / filteredSumPcs).toFixed(2)
    );
    const filteredSumWeight = parseFloat(
      _.sumBy(filteredData, "weight").toFixed(2)
    );

    // Filtered weights
    const filteredWeights = filteredData.map((item) => ({
      rW_Weight: item.rW_Weight || 0,
      r_Weight: item.r_Weight || 0,
      eM_Weight: item.eM_Weight || 0,
      oV_Weight: item.oV_Weight || 0,
      pN_Weight: item.pN_Weight || 0,
      cU_Weight: item.cU_Weight || 0,
    }));

    // Calculate sum of weights for each property
    const filteredSumRW_Weight = parseFloat(
      _.sumBy(filteredWeights, "rW_Weight").toFixed(2)
    );
    const filteredSumR_Weight = parseFloat(
      _.sumBy(filteredWeights, "r_Weight").toFixed(2)
    );
    const filteredSumEM_Weight = parseFloat(
      _.sumBy(filteredWeights, "eM_Weight").toFixed(2)
    );
    const filteredSumOV_Weight = parseFloat(
      _.sumBy(filteredWeights, "oV_Weight").toFixed(2)
    );
    const filteredSumPN_Weight = parseFloat(
      _.sumBy(filteredWeights, "pN_Weight").toFixed(2)
    );
    const filteredSumCU_Weight = parseFloat(
      _.sumBy(filteredWeights, "cU_Weight").toFixed(2)
    );

    return {
      footerTotalPcs: filteredSumPcs,
      footerTotalLength: isNaN(filteredSumLength) ? 0 : filteredSumLength,
      footerTotalWidth: isNaN(filteredSumWidth) ? 0 : filteredSumWidth,
      footerTotalHeight: isNaN(filteredSumHeight) ? 0 : filteredSumHeight,
      footerTotalWeight: filteredSumWeight,
      footerTotalRW_Weight: isNaN(filteredSumRW_Weight)
        ? 0
        : filteredSumRW_Weight,
      footerTotalR_Weight: isNaN(filteredSumR_Weight) ? 0 : filteredSumR_Weight,
      footerTotalEM_Weight: isNaN(filteredSumEM_Weight)
        ? 0
        : filteredSumEM_Weight,
      footerTotalOV_Weight: isNaN(filteredSumOV_Weight)
        ? 0
        : filteredSumOV_Weight,
      footerTotalPN_Weight: isNaN(filteredSumPN_Weight)
        ? 0
        : filteredSumPN_Weight,
      footerTotalCU_Weight: isNaN(filteredSumCU_Weight)
        ? 0
        : filteredSumCU_Weight,
    };
  };

  const updatePinnedBottomRowData = (event) => {
    const sums = calculateSums(event);
    pinnedBottomRowData[0].pcs = sums.footerTotalPcs;
    pinnedBottomRowData[0].length = sums.footerTotalLength;
    pinnedBottomRowData[0].width = sums.footerTotalWidth;
    pinnedBottomRowData[0].height = sums.footerTotalHeight;
    pinnedBottomRowData[0].weight = sums.footerTotalWeight;
    pinnedBottomRowData[0].rW_Weight = sums.footerTotalRW_Weight;
    pinnedBottomRowData[0].r_Weight = sums.footerTotalR_Weight;
    pinnedBottomRowData[0].eM_Weight = sums.footerTotalEM_Weight;
    pinnedBottomRowData[0].oV_Weight = sums.footerTotalOV_Weight;
    pinnedBottomRowData[0].pN_Weight = sums.footerTotalPN_Weight;
    pinnedBottomRowData[0].cU_Weight = sums.footerTotalCU_Weight;
  };

  const onFilterChanged = (event) => {
    updatePinnedBottomRowData(event);
    if (event) {
      event.api.refreshCells({ force: true, suppressFlash: true });
    }
  };

  //End New Code

  // const exportToExcel = () => {
  //   const fileType =
  //     "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
  //   const fileExtension = ".xlsx";
  //   const ws = XLSX.utils.json_to_sheet(stoneList);
  //   const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
  //   const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
  //   const data = new Blob([excelBuffer], { type: fileType });
  //   const fileName = "stone_list" + fileExtension;
  //   XLSX.writeFile(wb, fileName);
  // };
  const exportToExcel = () => {
    const fileName = "Jangad_stock_list.xlsx";

    // Define the columns based on columnDefs for stock list
    const stockColumns = [
      {
        header: "Date",
        key: "receivedDate",
        formatter: (value) => ISOToDateTime(value),
      },
      { header: "No", key: "stoneNo" },
      { header: "Type", key: "stoneType" },
      { header: "Pcs", key: "pcs" },
      { header: "Length", key: "length" },
      { header: "Width", key: "width" },
      { header: "Height", key: "height" },
      { header: "Weight", key: "weight" },
      { header: "RD", key: "r_Weight" },
      { header: "RD%", key: "r_Per" },
      { header: "EM", key: "eM_Weight" },
      { header: "EM%", key: "eM_Per" },
      { header: "OV", key: "oV_Weight" },
      { header: "OV%", key: "oV_Per" },
      { header: "PN", key: "pN_Weight" },
      { header: "PN%", key: "pN_Per" },
      { header: "CU", key: "cU_Weight" },
      { header: "CU%", key: "cU_Per" },
    ];

    // Format the stock data based on the columns
    const formattedStockData = stoneList.map((item) => {
      const formattedItem = {};
      stockColumns.forEach((col) => {
        formattedItem[col.header] = col.formatter
          ? col.formatter(item[col.key])
          : item[col.key];
      });
      return formattedItem;
    });

    // Calculate totals and averages for stock data
    const stockItemCount = stoneList.length;
    const stockTotalPcs = stoneList.reduce((sum, item) => sum + item.pcs, 0);

    const stockAvgLength = (
      stoneList.reduce((sum, item) => sum + item.length, 0) / stockItemCount
    ).toFixed(2);
    const stockAvgWidth = (
      stoneList.reduce((sum, item) => sum + item.width, 0) / stockItemCount
    ).toFixed(2);
    const stockAvgHeight = (
      stoneList.reduce((sum, item) => sum + item.height, 0) / stockItemCount
    ).toFixed(2);

    const stockTotalWeight = stoneList
      .reduce((sum, item) => sum + item.weight, 0)
      .toFixed(2);

    const stockTotalRWeight = stoneList
      .reduce((sum, item) => sum + item.rW_Weight, 0)
      .toFixed(2);
    const stockTotalEMWeight = stoneList
      .reduce((sum, item) => sum + item.eM_Weight, 0)
      .toFixed(2);
    const stockTotalOVWeight = stoneList
      .reduce((sum, item) => sum + item.oV_Weight, 0)
      .toFixed(2);
    const stockTotalPNWeight = stoneList
      .reduce((sum, item) => sum + item.pN_Weight, 0)
      .toFixed(2);
    const stockTotalCUWeight = stoneList
      .reduce((sum, item) => sum + item.cU_Weight, 0)
      .toFixed(2);

    const stockTotals = {
      Date: "",
      No: "",
      CH: "",
      Type: "Total",
      Pcs: stockTotalPcs,
      Length: stockAvgLength,
      Width: stockAvgWidth,
      Height: stockAvgHeight,
      Weight: stockTotalWeight,
      RD: stockTotalRWeight,
      RD_Per: "0",
      EM: stockTotalEMWeight,
      EM_Per: "0",
      OV: stockTotalOVWeight,
      OV_Per: "0",
      PN: stockTotalPNWeight,
      PN_Per: "0",
      CU: stockTotalCUWeight,
      CU_Per: "0",
    };

    const workbook = new ExcelJS.Workbook();

    // Add stock list worksheet
    const stockWorksheet = workbook.addWorksheet("Stock List");

    // Set the worksheet columns for stock list
    stockWorksheet.columns = stockColumns.map((col) => ({
      header: col.header,
      key: col.header,
      width: 20,
    }));

    // Add the formatted stock data to the worksheet
    stockWorksheet.addRows(formattedStockData);

    // Add the totals row in stock worksheet
    stockWorksheet.addRow(stockTotals);

    // Style the header row in stock worksheet
    const stockHeaderRow = stockWorksheet.getRow(1); // Header row is now the first row
    stockHeaderRow.eachCell((cell) => {
      cell.font = { bold: true, color: { argb: "FFFFFFFF" } };
      cell.fill = {
        type: "pattern",
        pattern: "solid",
        fgColor: { argb: "FF4F81BD" },
      };
      cell.alignment = { horizontal: "center", vertical: "middle" };
    });

    // Style the totals row in stock worksheet
    const stockTotalsRow = stockWorksheet.getRow(stockWorksheet.lastRow.number);
    stockTotalsRow.eachCell((cell) => {
      cell.font = { bold: true };
      cell.alignment = { horizontal: "center", vertical: "middle" };
    });

    // Adjust column widths based on content length in stock worksheet
    stockWorksheet.columns.forEach((column) => {
      let maxLength = column.header.length;
      formattedStockData.forEach((row) => {
        const cellValue = row[column.key];
        if (cellValue) {
          maxLength = Math.max(maxLength, cellValue.toString().length);
        }
      });
      const totalsValue = stockTotals[column.key];
      if (totalsValue) {
        maxLength = Math.max(maxLength, totalsValue.toString().length);
      }
      column.width = maxLength + 2; // Add padding
    });

    workbook.xlsx.writeBuffer().then((buffer) => {
      const blob = new Blob([buffer], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      saveAs(blob, fileName);
    });
  };

  const columnDefs = [
    {
      headerCheckboxSelection: true,
      checkboxSelection: true,
      headerCheckboxSelectionFilteredOnly: true,
      width: 50,
      headerClass: "centered-header",
      pinned: "left",
    },
    {
      headerName: "Date",
      field: "receivedDate",
      flex: 1,
      minWidth: 200,
      sortable: true,
      filter: "agDateColumnFilter",
      wrapHeaderText: true,
      autoHeaderHeight: true,
      wrapText: false,
      autoHeight: false,
      cellStyle: { textAlign: "left" },
      valueFormatter: (params) => {
        if (params.value) {
          return ISOToDateTime(params.value);
        }
        return "";
      },
    },
    {
      headerName: "No",
      field: "stoneNo",
      sortable: true,
      filter: true,
      wrapHeaderText: true,
      autoHeaderHeight: true,
      wrapText: false,
      autoHeight: false,
      cellStyle: { textAlign: "left" },
      flex: 1,
      minWidth: 100,
    },
    {
      headerName: "Type",
      field: "stoneType",
      sortable: true,
      filter: true,
      wrapHeaderText: true,
      autoHeaderHeight: true,
      wrapText: false,
      autoHeight: false,
      cellStyle: { textAlign: "left" },
      flex: 1,
      minWidth: 100,
    },
    {
      headerName: "Pcs",
      field: "pcs",
      flex: 1,
      sortable: true,
      filter: true,
      wrapHeaderText: true,
      autoHeaderHeight: true,
      wrapText: false,
      autoHeight: false,
      cellStyle: { textAlign: "left" },
      cellRenderer: ({ value, data }) => {
        // Check if value is zero
        if (value === 0) {
          return "0"; // Display "0" if value is zero
        } else {
          return value;
        }
      },
      aggFunc: sumAggFunc,
      minWidth: 100, // Use the sumAggFunc for aggregation
    },
    {
      headerName: "Length",
      field: "length",
      sortable: true,
      filter: true,
      wrapHeaderText: true,
      autoHeaderHeight: true,
      wrapText: false,
      autoHeight: false,
      cellStyle: { textAlign: "left" },
      cellRenderer: ({ value, data }) => {
        // Check if value is zero
        if (value === 0) {
          return "0"; // Display "0" if value is zero
        } else {
          return value.toFixed(2);
        }
      },
      aggFunc: sumAggFunc,
      flex: 1,
      minWidth: 100, // Use the sumAggFunc for aggregation
    },
    {
      headerName: "Width",
      field: "width",
      sortable: true,
      filter: true,
      wrapHeaderText: true,
      autoHeaderHeight: true,
      wrapText: false,
      autoHeight: false,
      cellStyle: { textAlign: "left" },
      cellRenderer: ({ value, data }) => {
        // Check if value is zero
        if (value === 0) {
          return "0"; // Display "0" if value is zero
        } else {
          return value.toFixed(2);
        }
      },
      aggFunc: sumAggFunc,
      flex: 1,
      minWidth: 100, // Use the sumAggFunc for aggregation
    },
    {
      headerName: "Height",
      field: "height",
      sortable: true,
      filter: true,
      wrapHeaderText: true,
      autoHeaderHeight: true,
      wrapText: false,
      autoHeight: false,
      cellStyle: { textAlign: "left" },
      cellRenderer: ({ value, data }) => {
        // Check if value is zero
        if (value === 0) {
          return "0"; // Display "0" if value is zero
        } else {
          return value.toFixed(2);
        }
      },
      aggFunc: sumAggFunc,
      flex: 1,
      minWidth: 100, // Use the sumAggFunc for aggregation
    },
    {
      headerName: "Weight",
      field: "weight",
      sortable: true,
      filter: true,
      wrapHeaderText: true,
      autoHeaderHeight: true,
      wrapText: false,
      autoHeight: false,
      cellStyle: { textAlign: "left" },
      cellRenderer: ({ value, data }) => value.toFixed(2),
      aggFunc: sumAggFunc,
      flex: 1,
      minWidth: 100, // Use the sumAggFunc for aggregation
    },
    // {
    //   headerName: "Rough",
    //   field: "rW_Weight",
    //   flex: 1,
    //   sortable: true,
    //   filter: true,
    //   wrapHeaderText: true,
    //   autoHeaderHeight: true,
    //   wrapText: false,
    //   autoHeight: false,
    //   cellStyle: { textAlign: "left" },
    //   cellRenderer: ({ value, data }) => {
    //     // Check if value is zero
    //     if (value === 0 || value == null) {
    //       return "0"; // Display "0" if value is zero
    //     } else {
    //       return value.toFixed(2);
    //     }
    //   },
    //   aggFunc: sumAggFunc,
    //   flex: 1,
    //   minWidth: 100, // Use the sumAggFunc for aggregation
    // },
    {
      headerName: "RD",
      field: "r_Weight",
      sortable: true,
      filter: true,
      wrapHeaderText: true,
      autoHeaderHeight: true,
      wrapText: false,
      autoHeight: false,
      cellStyle: { textAlign: "left" },
      cellRenderer: ({ value, data }) => {
        // Check if value is zero
        if (value === 0 || value == null) {
          return "0"; // Display "0" if value is zero
        } else {
          return value.toFixed(2);
        }
      },
      aggFunc: sumAggFunc,
      flex: 1,
      minWidth: 100, // Use the sumAggFunc for aggregation
    },
    {
      headerName: "RD%",
      field: "r_Per",
      sortable: true,
      filter: true,
      wrapHeaderText: true,
      autoHeaderHeight: true,
      wrapText: false,
      autoHeight: false,
      cellStyle: { textAlign: "left" },
      cellRenderer: ({ value, data }) => {
        // Check if value is zero
        if (value === 0 || value == null) {
          return "0"; // Display "0" if value is zero
        } else {
          return value + "%";
        }
      },
      aggFunc: sumAggFunc,
      flex: 1,
      minWidth: 100, // Use the sumAggFunc for aggregation
    },
    {
      headerName: "EM",
      field: "eM_Weight",
      flex: 1,
      sortable: true,
      filter: true,
      wrapHeaderText: true,
      autoHeaderHeight: true,
      wrapText: false,
      autoHeight: false,
      cellStyle: { textAlign: "left" },
      cellRenderer: ({ value, data }) => {
        // Check if value is zero
        if (value === 0 || value == null) {
          return "0"; // Display "0" if value is zero
        } else {
          return value.toFixed(2);
        }
      },
      aggFunc: sumAggFunc,
      minWidth: 100, // Use the sumAggFunc for aggregation
    },
    {
      headerName: "EM%",
      field: "eM_Per",
      sortable: true,
      filter: true,
      wrapHeaderText: true,
      autoHeaderHeight: true,
      wrapText: false,
      autoHeight: false,
      cellStyle: { textAlign: "left" },
      cellRenderer: ({ value, data }) => {
        // Check if value is zero
        if (value === 0 || value == null) {
          return "0"; // Display "0" if value is zero
        } else {
          return value.toFixed(2) + "%";
        }
      },
      aggFunc: sumAggFunc,
      flex: 1,
      minWidth: 100, // Use the sumAggFunc for aggregation
    },
    {
      headerName: "OV",
      field: "oV_Weight",
      sortable: true,
      filter: true,
      wrapHeaderText: true,
      autoHeaderHeight: true,
      wrapText: false,
      autoHeight: false,
      cellStyle: { textAlign: "left" },
      cellRenderer: ({ value, data }) => {
        // Check if value is zero
        if (value === 0 || value == null) {
          return "0"; // Display "0" if value is zero
        } else {
          return value.toFixed(2);
        }
      },
      aggFunc: sumAggFunc,
      flex: 1,
      minWidth: 100, // Use the sumAggFunc for aggregation
    },
    {
      headerName: "OV%",
      field: "oV_Per",
      flex: 1,
      sortable: true,
      filter: true,
      wrapHeaderText: true,
      autoHeaderHeight: true,
      wrapText: false,
      autoHeight: false,
      cellStyle: { textAlign: "left" },
      cellRenderer: ({ value, data }) => {
        // Check if value is zero
        if (value === 0 || value == null) {
          return "0"; // Display "0" if value is zero
        } else {
          return value.toFixed(2) + "%";
        }
      },
      aggFunc: sumAggFunc,
      minWidth: 100, // Use the sumAggFunc for aggregation
    },
    {
      headerName: "PN",
      field: "pN_Weight",
      flex: 1,
      sortable: true,
      filter: true,
      wrapHeaderText: true,
      autoHeaderHeight: true,
      wrapText: false,
      autoHeight: false,
      cellStyle: { textAlign: "left" },
      cellRenderer: ({ value, data }) => {
        // Check if value is zero
        if (value === 0 || value == null) {
          return "0"; // Display "0" if value is zero
        } else {
          return value.toFixed(2);
        }
      },
      aggFunc: sumAggFunc,
      minWidth: 100, // Use the sumAggFunc for aggregation
    },
    {
      headerName: "PN%",
      field: "pN_Per",
      sortable: true,
      filter: true,
      wrapHeaderText: true,
      autoHeaderHeight: true,
      wrapText: false,
      autoHeight: false,
      cellStyle: { textAlign: "left" },
      cellRenderer: ({ value, data }) => {
        // Check if value is zero
        if (value === 0 || value == null) {
          return "0"; // Display "0" if value is zero
        } else {
          return value.toFixed(2) + "%";
        }
      },
      aggFunc: sumAggFunc,
      flex: 1,
      minWidth: 100, // Use the sumAggFunc for aggregation
    },
    {
      headerName: "CU",
      field: "cU_Weight",
      sortable: true,
      filter: true,
      wrapHeaderText: true,
      autoHeaderHeight: true,
      wrapText: false,
      autoHeight: false,
      cellStyle: { textAlign: "left" },
      cellRenderer: ({ value, data }) => {
        // Check if value is zero
        if (value === 0 || value == null) {
          return "0"; // Display "0" if value is zero
        } else {
          return value.toFixed(2);
        }
      },
      aggFunc: sumAggFunc,
      flex: 1,
      minWidth: 100, // Use the sumAggFunc for aggregation
    },
    {
      headerName: "CU%",
      field: "cU_Per",
      sortable: true,
      filter: true,
      wrapHeaderText: true,
      autoHeaderHeight: true,
      wrapText: false,
      autoHeight: false,
      cellStyle: { textAlign: "left" },
      cellRenderer: ({ value, data }) => {
        // Check if value is zero
        if (value === 0 || value == null) {
          return "0"; // Display "0" if value is zero
        } else {
          return value.toFixed(2) + "%";
        }
      },
      aggFunc: sumAggFunc,
      flex: 1,
      minWidth: 100, // Use the sumAggFunc for aggregation
    },
  ];

  const handleCheckboxSelection = (event) => {
    const selectedRows = event.api.getSelectedRows();
    const selectedBagRow = Array.isArray(selectedRows) ? selectedRows : [];
    selectedBagForCreateJangad = selectedBagRow;
  };

  // Code For Jangad Popap
  const [selectedBagForJangad, setSelectedBagForJangad] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [partyMasterName, setPartyMasterName] = useState([]);
  const [selectedDate, setSelectedDate] = useState(getCurrentDate());
  const [selectedParty, setSelectedParty] = useState("");

  const handlepartymasterChange = (option) => {
    setSelectedParty(option);
  };

  useEffect(() => {
    getAllPartyMsater();
  }, []);

  const getAllPartyMsater = () => {
    return api
      .get("PartyMaster/All")
      .then((result) => {
        setPartyMasterName(result.data.data);
        return result.data.data;
      })
      .catch((error) => {
        console.log(error);
        throw error; // Rethrow the error to propagate it to the caller
      });
  };

  const InsertJangad = () => {
    setIsLoading(true);
    if (!selectedDate) {
      toast.error("Please Select Date.");
      setIsLoading(false);
      return;
    }
    if (!selectedParty) {
      toast.error("Please Select Party.");
      setIsLoading(false);
      return;
    }
    if (selectedBagForCreateJangad.length === 0) {
      toast.error("Please add ASI details.");
      setIsLoading(false);
      return;
    }

    const data = {
      Date: selectedDate,
      PartyMasterID: selectedParty.value,
      BagData: selectedBagForCreateJangad,
    };

    api
      .post(`Jangad/InsertJangadData`, data)
      .then((result) => {
        toast.success(result.data.message);
        setSelectedBagForJangad([]);
        selectedBagForCreateJangad = [];
        setSelectedDate("");
        setSelectedParty(null);
      })
      .catch((error) => {
        console.log(error);
        toast.error("An error occurred");
        setIsLoading(false);
      })
      .finally(() => {
        setIsModalOpen(false);
        setIsLoading(false);
        getStockList();
      });
  };

  const closeModal = () => {
    setSelectedBagForJangad([]);
    selectedBagForCreateJangad = [];
    setSelectedDate("");
    setSelectedParty(null);
    setIsModalOpen(false);
    getStockList();
  };

  const JangadModelOpen = () => {
    if (selectedBagForCreateJangad.length > 0) {
      setIsModalOpen(true);
    } else {
      toast.error("Select A ASI");
    }
  };

  // Code For Add Party MASTER
  const [showPartyMasterModel, setShowPartyMasterModel] = useState(false);

  const selectDDJangadID = (partyMasterID) => {
    getAllPartyMsater()
      .then((data) => {
        const selectedParty = data.find(
          (f) => f.partyMasterID === partyMasterID
        );
        if (selectedParty) {
          var option = {
            value: partyMasterID,
            label: selectedParty.partyName,
          };
          handlepartymasterChange(option);
          setShowPartyMasterModel(false);
        } else {
          console.error("Party master not found for ID:", partyMasterID);
          // Optionally, handle the case where party master is not found
        }
      })
      .catch((error) => {
        console.error("Error fetching party master data:", error);
        // Optionally, handle the error
      });
  };

  //Print Section Start
  const PrintPreview = ({ stoneDetails }) => {
    const totals = stoneDetails.reduce(
      (acc, stone) => {
        acc.pcs += stone.pcs;
        acc.length += stone.length;
        acc.width += stone.width;
        acc.height += stone.height;
        acc.weight += stone.weight;
        acc.r_Weight += stone.r_Weight;
        acc.r_Per += stone.r_Per;
        acc.eM_Weight += stone.eM_Weight;
        acc.eM_Per += stone.eM_Per;
        acc.oV_Weight += stone.oV_Weight;
        acc.oV_Per += stone.oV_Per;
        acc.pN_Weight += stone.pN_Weight;
        acc.pN_Per += stone.pN_Per;
        acc.cU_Weight += stone.cU_Weight;
        acc.cU_Per += stone.cU_Per;

        return acc;
      },
      {
        pcs: 0,
        length: 0,
        width: 0,
        height: 0,
        weight: 0,
        r_Weight: 0,
        r_Per: 0,
        eM_Weight: 0,
        eM_Per: 0,
        oV_Weight: 0,
        oV_Per: 0,
        pN_Weight: 0,
        pN_Per: 0,
        cU_Weight: 0,
        cU_Per: 0,
      }
    );

    // Calculate average values
    // const itemCount = stoneDetails.length;
    // const avgLength = itemCount ? (totals.length / itemCount).toFixed(2) : 0;
    // const avgWidth = itemCount ? (totals.width / itemCount).toFixed(2) : 0;
    // const avgHeight = itemCount ? (totals.height / itemCount).toFixed(2) : 0;

    return (
      <>
        <div style={{}}>
          <table
            className="table table-bordered"
            style={{
              fontSize: "12px",
              lineHeight: "8px",
              marginTop: "-1px",
              borderColor: "#000",
            }}
          >
            <thead>
              <tr>
                <th
                  colSpan={16}
                  style={{ textAlign: "center", fontSize: "14px" }}
                >
                  Final Stock List
                </th>
              </tr>
              <tr>
                <th style={{ textAlign: "center" }}>No</th>
                <th style={{ textAlign: "left", minWidth: "140px" }}>Date</th>
                <th style={{ textAlign: "center", minWidth: "70px" }}>No</th>
                <th style={{ textAlign: "center" }}>Type</th>
                <th style={{ textAlign: "center" }}>PCS</th>
                <th style={{ textAlign: "center" }}>Weight</th>
                <th style={{ textAlign: "center" }}>RD</th>
                <th style={{ textAlign: "center" }}>RD%</th>
                <th style={{ textAlign: "center" }}>EM</th>
                <th style={{ textAlign: "center" }}>EM%</th>
                <th style={{ textAlign: "center" }}>OV</th>
                <th style={{ textAlign: "center" }}>OV%</th>
                <th style={{ textAlign: "center" }}>PN</th>
                <th style={{ textAlign: "center" }}>PN%</th>
                <th style={{ textAlign: "center" }}>CU</th>
                <th style={{ textAlign: "center" }}>CU%</th>
              </tr>
            </thead>
            <tbody>
              {stoneDetails.map((stone, index) => (
                <tr key={index}>
                  <td style={{ textAlign: "center" }}>{index + 1}</td>
                  <td style={{ textAlign: "left", minWidth: "140px" }}>
                    {ISOToDateTime(stone.receivedDate)}
                  </td>
                  <td style={{ textAlign: "center", minWidth: "70px" }}>{stone.stoneNo}</td>
                  <td style={{ textAlign: "center" }}>{stone.stoneType}</td>
                  <td style={{ textAlign: "center" }}>{stone.pcs}</td>
                  <td style={{ textAlign: "center" }}>{stone.weight}</td>
                  <td style={{ textAlign: "center" }}>{stone.r_Weight}</td>
                  <td style={{ textAlign: "center" }}>{stone.r_Per}</td>
                  <td style={{ textAlign: "center" }}>{stone.eM_Weight}</td>
                  <td style={{ textAlign: "center" }}>{stone.eM_Per}</td>
                  <td style={{ textAlign: "center" }}>{stone.oV_Weight}</td>
                  <td style={{ textAlign: "center" }}>{stone.oV_Per}</td>
                  <td style={{ textAlign: "center" }}>{stone.pN_Weight}</td>
                  <td style={{ textAlign: "center" }}>{stone.pN_Per}</td>
                  <td style={{ textAlign: "center" }}>{stone.cU_Weight}</td>
                  <td style={{ textAlign: "center" }}>{stone.cU_Per}</td>
                </tr>
              ))}
            </tbody>
            <tfoot>
              <tr style={{ fontWeight: "bold" }}>
                <td colSpan="4" style={{ textAlign: "right" }}>
                  Total
                </td>
                <td style={{ textAlign: "center" }}>{totals.pcs}</td>
                {/* <td style={{ textAlign: "center" }}>{avgLength}</td>
                <td style={{ textAlign: "center" }}>{avgWidth}</td>
                <td style={{ textAlign: "center" }}>{avgHeight}</td> */}
                <td style={{ textAlign: "center" }}>
                  {totals.weight.toFixed(2)}
                </td>
                <td style={{ textAlign: "center" }}>
                  {totals.r_Weight.toFixed(2)}
                </td>
                <td>0</td>
                <td style={{ textAlign: "center" }}>
                  {totals.eM_Weight.toFixed(2)}
                </td>
                <td>0</td>
                <td style={{ textAlign: "center" }}>
                  {totals.oV_Weight.toFixed(2)}
                </td>
                <td>0</td>
                <td style={{ textAlign: "center" }}>
                  {totals.pN_Weight.toFixed(2)}
                </td>
                <td>0</td>
                <td style={{ textAlign: "center" }}>
                  {totals.cU_Weight.toFixed(2)}
                </td>
                <td>0</td>
              </tr>
            </tfoot>
          </table>
        </div>
      </>
    );
  };

  const printCurrentJangadReport = (stoneList) => {
    if (selectedBagForCreateJangad.length > 0) {
      const StoneDetailsForPrint = selectedBagForCreateJangad;



      const printWindow = window.open("", "_blank");

      printWindow.document.write(
        '<html><head><title>Print Barcode</title><link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/bootstrap@5.3.0/dist/css/bootstrap.min.css"><style>{{width:"760px;"}}</style></head><body>'
      );

      ReactDOM.render(
        <PrintPreview stoneDetails={StoneDetailsForPrint} />,
        printWindow.document.body
      );

      printWindow.document.write("</body></html>");

      setTimeout(() => {
        printWindow.print();
        printWindow.close();
      }, 200);
    } else {
      toast.error("Select A ASI");
    }
  };

  return (
    <>
      {isLoading && <Loader />}
      <div>
        <div className="card">
          <div className="card-body">
            <div className="dashboardSummaryContainer">
              <div className="dashboardSummaryItem">
                <FontAwesomeIcon className="Icon1" icon={faGem} />
                <h4>Total Stone</h4>
                <h2>{totalStock.totalPcs}</h2>
              </div>
              <div className="dashboardSummaryItem">
                <FontAwesomeIcon className="Icon1" icon={faArrowsLeftRight} />
                <h4>Avg. Length</h4>
                <h2>{totalStock.totalLength}</h2>
              </div>
              <div className="dashboardSummaryItem">
                <FontAwesomeIcon className="Icon1" icon={faArrowsLeftRight} />
                <h4>Avg. Width</h4>
                <h2>{totalStock.totalWidth}</h2>
              </div>
              <div className="dashboardSummaryItem">
                <FontAwesomeIcon className="Icon1" icon={faArrowsUpDown} />
                <h4>Avg. Height</h4>
                <h2>{totalStock.totalHeight}</h2>
              </div>
              <div className="dashboardSummaryItem">
                <FontAwesomeIcon className="Icon1" icon={faDumbbell} />
                <h4>Total Weight</h4>
                <h2>{totalStock.totalWeight}</h2>
              </div>
            </div>
          </div>
        </div>
        <div className="card">
          <div className="card-header d-flex justify-content-between align-items-center">
            <span>Current Stock List</span>
            <div className="d-flex align-items-center">
              <Button
                variant="primary"
                style={{ marginRight: "10px" }}
                className="mr-2"
                onClick={JangadModelOpen}
              >
                Create Jangad
              </Button>
              <Button
                variant="success"
                style={{ marginRight: "10px" }}
                onClick={exportToExcel}
              >
                <i class="fa fa-file-excel"></i> Export to Excel
              </Button>
              <Button
                variant="primary"
                onClick={() => printCurrentJangadReport(stoneList)}
              >
                <i class="fa fa-print"></i> Print
              </Button>
            </div>
          </div>
          <div className="card-body">``
            <AgGridComponent
              columnDefs={columnDefs}
              //defaultColDef={defaultColDef}
              rowData={stoneList}
              onSelectionChanged={handleCheckboxSelection}
              onFilterChanged={onFilterChanged}
              pinnedBottomRowData={pinnedBottomRowData}
              paginationPageSize={100}
              height={"70vh"}
            />
          </div>
        </div>
      </div>

      <Modal
        show={isModalOpen}
        onHide={closeModal}
        size="xl"
        dialogClassName="modal-90w"
        aria-labelledby="example-custom-modal-styling-title"
      >
        {isLoading && <Loader />}
        <Modal.Header closeButton closeVariant={"white"}>
          <Modal.Title id="example-custom-modal-styling-title">
            Create Jangad
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form.Group>
            <Form.Group
              as={Row}
              className="mb-3"
              controlId="formPlaintextEmail"
            >
              <Form.Label column sm="2">
                Date :
              </Form.Label>
              <Col sm="6">
                <Form.Group controlId="stoneTypeSelect">
                  <Form.Control
                    type="date"
                    name="selectedDate"
                    placeholder="Select Date"
                    value={selectedDate}
                    onChange={(e) => setSelectedDate(e.target.value)}
                    required
                  />
                  <Form.Control.Feedback type="invalid">
                    Please Enter The Value PartyName
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
            </Form.Group>
            <Form.Group
              as={Row}
              className="mb-3"
              controlId="formPlaintextEmail"
            >
              <Form.Label column sm="2">
                Party :
              </Form.Label>
              <Col sm="6">
                <div className="mb-3 d-flex justify-content-between">
                  <Select
                    value={selectedParty}
                    onChange={handlepartymasterChange}
                    options={partyMasterName.map((option) => ({
                      value: option.partyMasterID,
                      label: option.partyName,
                    }))}
                    placeholder="--Select Party--"
                  />
                  <div className="selectEndIcon input-group-text">
                    <i
                      className="fa fa-plus plusIcon"
                      onClick={() => setShowPartyMasterModel(true)}
                    ></i>
                  </div>
                </div>
              </Col>
            </Form.Group>
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <Button onClick={InsertJangad}>Save</Button>
        </Modal.Footer>
      </Modal>

      <Modal
        show={showPartyMasterModel}
        onHide={() => setShowPartyMasterModel(false)}
        size="xl"
        dialogClassName="custom-modal"
      >
        <Modal.Header closeButton>
          <Modal.Title>Add PartyMaster Data</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {
            <Form.Group>
              <PartyMasterDD partyMasterID={selectDDJangadID}></PartyMasterDD>
            </Form.Group>
          }
        </Modal.Body>
      </Modal>
    </>
  );
}
